// extracted by mini-css-extract-plugin
export var content = "info_accord-module--content--a9922";
export var copy = "info_accord-module--copy--f668a";
export var info_acc = "info_accord-module--info_acc--1d8f6";
export var info_accs = "info_accord-module--info_accs--b3b42";
export var info_btn = "info_accord-module--info_btn--b3d28";
export var subtitle = "info_accord-module--subtitle--c7702";